function StagingWarning() {
  return (
    <div id="staging-warning" className="text-brand-red-600 text-2xl">
      WARNING: This is a staging version of the dashboard. Don't use it for real customers!
    </div>
  );
}

export default StagingWarning;
